module.exports = __webpack_public_path__ + "static/media/Screenshot_3-thumb.29a48496.png";